import React, { memo } from 'react';

import downloadFile from '../../utils/downloadFile';
import Button from '../helpers/Button';

const AttachmentRendererComponent = ({ data }) => {
  const handleDownload = (url, name) => {
    downloadFile({
      url,
      noAuth: true,
      name,
    });
  };

  return data.attachments?.map(file => (
    <div key={file.id} className="truncate-text d-flex align-items-center">
      <Button className="btn-link truncate-text" onClick={() => handleDownload(file.url, file.originalName)}>
        {file.originalName}
      </Button>
    </div>
  ));
};

export const AttachmentRenderer = memo(AttachmentRendererComponent);
